import {
    Button,
    Card,
    Col,
    DatePicker,
    Divider,
    Form,
    Input,
    message,
    Modal,
    Row,
    Select,
    Space,
    Spin,
    Switch,
    Table,
    Tag,
    Tooltip
} from "antd";
import {useEffect, useState} from "react";
import {faUserGear} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    EditOutlined,
    EyeOutlined,
    QuestionCircleOutlined,
    ReloadOutlined,
    SaveOutlined,
    UserAddOutlined
} from "@ant-design/icons";
import {Link} from "react-router-dom";
import Validation from "../../../util/Validation";
import {
    EMAIL_MAX_LENGTH,
    EMAIL_VALIDATION,
    MOBILE_NUMBER_MAX_LENGTH,
    NIC_VALIDATION,
    ONLY_NUMERIC_VALIDATION,
    PARAMETER_LIST,
    PASSWORD_VALIDATION,
    USERNAME_VALIDATION
} from "../../../util/Constants";
import signupService from "../../../service/signupService";
import {
    MSG_ADMIN_USER_CREATED_FAILURE,
    MSG_ADMIN_USER_CREATED_SUCCESS,
    MSG_ADMIN_USER_UPDATE_FAILURE,
    MSG_ADMIN_USER_UPDATED_SUCCESS,
    MSG_AGENT_CODE_ALREADY_TAKEN,
    MSG_CODE_VALIDATION_FAILURE_ERROR,
    MSG_MANGER_CODE_ALREADY_TAKEN,
    MSG_NO_CHANGES_TO_UPDATE,
    MSG_PASSWORD_UPDATE_FAILURE,
    MSG_PASSWORD_UPDATED_SUCCESS,
    MSG_PLEASE_ENTER_A_VALID_EMAIL,
    MSG_RM_CODE_ALREADY_TAKEN,
    MSG_SAME_AGENT_CODE_ERROR,
    MSG_USER_GROUP_FETCH_FAILURE,
    MSG_USERNAME_ALREADY_TAKEN,
    MSG_USERNAME_VALIDATION_FAILURE_ERROR
} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {UserMstDto} from "../../../dto/UserMstDto";
import TableSearchComp from "../../../components/common/tableSearch/TableSearchComp";
import CommonFunction from "../../../util/CommonFunction";
import dayjs from "dayjs";
import ListItemDto from "../../../dto/ListItemDto";
// import CryptoJS from 'crypto-js';

const InternalUsersList = () => {
    const [isLoading, setLoading] = useState(false);
    const [isConfirmPasswordDisabled, setConfirmPwDisabled] = useState(true);
    const [adminUserList, setAdminUserList] = useState<string[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCanShowManagerCode, setCanShowManagerCode] = useState(false);
    const [isCanShowRMCode, setCanShowRMCode] = useState(false);
    const [isCanShowAgentCode, setCanShowAgentCode] = useState(false);
    const [isCanShowAdminUserType, setCanShowAdminUserType] = useState(false);
    const [isCanShowUpdate, setCanShowUpdate] = useState(false);
    const [modalTitle, setModalTitle] = useState("Create Admin User");
    const [isUpdateUser, setIsUpdateUser] = useState<boolean>(false);
    const [recordStatus, setRecordStatus] = useState<boolean>(false);
    const [salutationList, setSalutationList] = useState<ListItemDto[]>([]);
    const [userList, setUserList] = useState<ListItemDto[]>([]);
    const [adminList, setAdminList] = useState<ListItemDto[]>([]);
    const [reportingToList, setReportingToList] = useState<ListItemDto[]>([]);
    const [userId, setUserId] = useState<string>();
    const [initialFormValues, setInitialFormValues] = useState<UserMstDto>();
    const [dateOfBirth, setDateOfBirth] = useState<any>();
    const [addon, setAddon] = useState<string>("94");
    const [form] = Form.useForm();
    const [restForm] = Form.useForm();

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            render: (text: any, rec: any, index: number) => {
                return (<span>{index + 1}</span>)
            }
        },
        {
            title: 'Username',
            dataIndex: 'userName',
            key: 'userName',
            sorter: (a: any, b: any) => {
                a = a.userName == null ? '' : a.userName
                b = b.userName == null ? '' : b.userName
                return a.localeCompare(b);
            },
            ...TableSearchComp('userName', 'Username'),
            render: (text: any) => (
                CommonFunction.validateText(text)
            ),
        },
        {
            title: 'First Name',
            dataIndex: 'firstName',
            key: 'firstName',
            sorter: (a: any, b: any) => {
                a = a.firstName == null ? '' : a.firstName
                b = b.firstName == null ? '' : b.firstName
                return a.localeCompare(b);
            },
            ...TableSearchComp('firstName', 'firstName'),
            render: (text: any) => (
                CommonFunction.validateText(text)
            ),
        },
        {
            title: 'Last Name',
            dataIndex: 'lastName',
            key: 'lastName',
            sorter: (a: any, b: any) => {
                a = a.lastName == null ? '' : a.lastName
                b = b.lastName == null ? '' : b.lastName
                return a.localeCompare(b);
            },
            ...TableSearchComp('lastName', 'lastName'),
            render: (text: any) => (
                CommonFunction.validateText(text)
            ),
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            sorter: (a: any, b: any) => {
                a = a.email == null ? '' : a.email
                b = b.email == null ? '' : b.email
                return a.localeCompare(b);
            },
            ...TableSearchComp('email', 'Email'),
            render: (text: any) => (
                CommonFunction.validateText(text)
            ),
        },
        {
            title: 'Agent Code',
            dataIndex: 'agentCode',
            key: 'agentCode',
            ...TableSearchComp('agentCode', 'Agent Code'),
            render: (text: any) => (
                CommonFunction.validateText(text)
            ),
        },
        {
            title: 'Created Date',
            dataIndex: 'createdDate',
            key: 'createdDate',
            sorter: (a: any, b: any) => {
                a = a.createdDate == null ? '' : a.createdDate
                b = b.createdDate == null ? '' : b.createdDate
                return a.localeCompare(b);
            },
            ...TableSearchComp('createdDate', 'Created Date'),
            render: (text: any) => (
                CommonFunction.validateText(text)
            ),
        },
        {
            title: 'Status',
            dataIndex: 'recordStatus',
            key: 'recordStatus',
            sorter: (a: any, b: any) => {
                return Number(a.recordStatus) - Number(b.recordStatus);
            },
            filters: [
                {
                    text: 'Active',
                    value: PARAMETER_LIST.ACTIVE,
                },
                {
                    text: 'Inactive',
                    value: PARAMETER_LIST.INACTIVE,
                }
            ],
            onFilter: (value: string, record: any) => {
                if (value === 'ACTIVE') {
                    return record.recordStatus === true;
                } else if (value === 'INACTIVE') {
                    return record.recordStatus === false;
                }
                return false;
            },
            render: (text: boolean) => (
                <>
                    {
                        text ?
                            <Tag color="success">
                                ACTIVE
                            </Tag> :
                            <Tag color="warning">
                                INACTIVE
                            </Tag>
                    }
                </>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            align: "center",
            fixed: 'right' as const,
            render: (text: any, rec: any) => (
                <Space size="middle">
                    <Tooltip placement="top" title='View'>
                        <Link to={{}}>
                            <Button className='btn-action-outline-common btn-action-view '
                                    icon={<EyeOutlined/>} onClick={() => onView(rec, 'VIEW')}>View</Button>
                        </Link>
                    </Tooltip>
                    <Tooltip placement="top" title='Update'>
                        <Link to={{}}>
                            <Button className='btn-action-outline-common btn-action-transfer'
                                    icon={<EditOutlined/>} onClick={() => onView(rec, 'UPDATE')}>Update</Button>
                        </Link>
                    </Tooltip>
                </Space>
            ),
        },
    ];
    useEffect(() => {
        getAllAdminUsers()
    }, []);

    const checkFieldUpdates = (oldValues: UserMstDto, newValues: UserMstDto | undefined) => {
        let isChanged = false;

        if (oldValues != null && newValues != null) {
            Object.keys(newValues).forEach((key) => {
                if ("userAttributes" !== key) {
                    const oldValue = oldValues[key as keyof UserMstDto];
                    const newValue = newValues[key as keyof UserMstDto];
                    if ("dateOfBirth" == key && (dateOfBirth?.toString() !== newValue?.toString())) {
                        isChanged = true;
                        return;
                    }
                    if (("dateOfBirth" != key) && newValue?.toString() != oldValue?.toString()) {
                        isChanged = true;
                        return;
                    }
                }
            });
        }
        return isChanged;
    };
    const removeCountryCode = (number: string | null): string | null => {
        if (undefined != number){
            return number.startsWith("94") ? number.slice(2) : number;
        }else {
            return number;
        }
    };
    const onView = (record: UserMstDto, type: string) => {
        if (type === 'VIEW') {
            setModalTitle("View Admin User")
            setCanShowUpdate(true)
            setIsUpdateUser(false)
        } else {
            setModalTitle("Update Admin User")
            setCanShowUpdate(false)
            setIsUpdateUser(true)
            setUserId(record.userId ?? '');
        }
        getAllUserType()
        getAllSalutation()
        getAllReportingTo()
        getAllAdminUserType()

        signupService.getUserWiseDetails(record.userName).then((res) => {
            let results = res.data.results;
            if (results) {
                let formattedContact = removeCountryCode(results.contact);
                const date = results.dateOfBirth
                const recordStatus = results.recordStatus
                const userTypeId = results.userTypeId
                results.contact = formattedContact;
                setInitialFormValues(results)


                if (results.adminUserTypeIdList.length > 0) {
                    setCanShowAdminUserType(true)
                }

                if (null != date) {
                    const dateOfBirth = dayjs(date);
                    setDateOfBirth(dateOfBirth.format("YYYY-MM-DD"))
                }
                setRecordStatus(recordStatus)
                results.dateOfBirth = null;
                form.setFieldsValue({
                    ...results,
                    dateOfBirth: date ? dayjs(date) : null,
                    recordStatus: recordStatus
                });
                if (userTypeId === 3) {
                    setCanShowManagerCode(true)
                    setCanShowRMCode(false)
                    setCanShowAgentCode(false)
                } else if (userTypeId === 5) {
                    setCanShowRMCode(true)
                    setCanShowManagerCode(false);
                    setCanShowAgentCode(false)
                } else {
                    setCanShowAgentCode(true)
                    setCanShowManagerCode(false);
                    setCanShowRMCode(false)
                }
                setLoading(false)
            } else {
                message.error(MSG_ADMIN_USER_UPDATE_FAILURE)
                setLoading(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setLoading(false)
        })
        setIsModalOpen(true);
    }

    const showModal = () => {
        setCanShowUpdate(false)
        setIsUpdateUser(false)
        setModalTitle("Create Admin User")
        getAllUserType()
        getAllSalutation()
        getAllReportingTo()
        getAllAdminUserType()
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setCanShowRMCode(false)
        setCanShowManagerCode(false)
        setCanShowAgentCode(false)
        setCanShowAdminUserType(false)
        setConfirmPwDisabled(true)
        setInitialFormValues(undefined);
        setDateOfBirth(null);
        form.resetFields()
        restForm.resetFields()
    };

    const getAllSalutation = () => {
        signupService.getAllSalutation().then((res: any) => {
            if (res.data !== null) {
                setSalutationList(res.data.results)
                setIsModalOpen(true);
            } else {
                setSalutationList([])
                message.error(MSG_USER_GROUP_FETCH_FAILURE).then();
            }
        }, (reason) => {
            setSalutationList([])
            ErrorHandler.handleError(reason);
        })
    }

    const getAllReportingTo = () => {
        signupService.getAllReportingTo().then((res: any) => {
            if (res.data !== null) {
                setReportingToList(res.data.results)
                setIsModalOpen(true);
            } else {
                setReportingToList([])
                message.error(MSG_USER_GROUP_FETCH_FAILURE).then();
            }
        }, (reason) => {
            setReportingToList([])
            ErrorHandler.handleError(reason);
        })
    }

    const getAllAdminUserType = () => {
        signupService.getAllAdminUserType().then((res: any) => {
            if (res.data !== null) {
                setAdminList(res.data.results)
                setIsModalOpen(true);
            } else {
                setAdminList([])
                message.error(MSG_USER_GROUP_FETCH_FAILURE).then();
            }
        }, (reason) => {
            setAdminList([])
            ErrorHandler.handleError(reason);
        })
    }

    const getAllUserType = () => {
        signupService.getAllUserType().then((res: any) => {
            if (res.data !== null) {
                setUserList(res.data.results)
                setIsModalOpen(true);
            } else {
                setUserList([])
                message.error(MSG_USER_GROUP_FETCH_FAILURE).then();
            }
        }, (reason) => {
            setUserList([])
            ErrorHandler.handleError(reason);
        })
    }

    const getAllAdminUsers = () => {
        setLoading(true)
        signupService.getAllAdminUsers().then((res: any) => {
            if (res.data !== null) {
                setAdminUserList(res.data.results)
                setLoading(false)
            } else {
                message.error(MSG_USER_GROUP_FETCH_FAILURE).then();
                setLoading(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setLoading(false)
        })
    }

    const validateUsername = (rule: any, value: any, callback: any) => {
        if (!isCanShowUpdate && !isUpdateUser && value) {
            signupService.validateUsername(value).then(res => {
                if (res.data !== null) {
                    if (res.data.results) {
                        callback(MSG_USERNAME_ALREADY_TAKEN)

                    } else {
                        callback()
                    }
                } else {
                    message.error(MSG_USERNAME_VALIDATION_FAILURE_ERROR).then();
                    callback()
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                callback()
            })
        } else {
            callback()
        }
    };

    const validateAgentCode = (rule: any, value: any, callback: any) => {
        if (value) {
            const username = form.getFieldValue('userName')
            signupService.validateAgentCode(value, username, isUpdateUser).then(res => {
                if (res.data !== null) {
                    if (res.data.results) {
                        if (isCanShowRMCode) {
                            callback(MSG_RM_CODE_ALREADY_TAKEN)
                        } else if (isCanShowManagerCode) {
                            callback(MSG_MANGER_CODE_ALREADY_TAKEN)
                        } else {
                            callback(MSG_AGENT_CODE_ALREADY_TAKEN)
                        }

                    } else {
                        callback()
                    }
                } else {
                    message.error(MSG_CODE_VALIDATION_FAILURE_ERROR).then();
                    callback()
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                callback()
            })
        } else {
            callback()
        }
    };

    const validateEmail = (_: any, value: any) => {
        if (!value) {
            return Promise.resolve();
        }
        if (value.length > EMAIL_MAX_LENGTH) {
            return Promise.reject();
        }
        if (!EMAIL_VALIDATION.test(value)) {
            return Promise.reject(MSG_PLEASE_ENTER_A_VALID_EMAIL);
        } else {
            return Promise.resolve();
        }

    };

    const validatePassword = (_: any, value: any) => {
        if (!value) {
            form.resetFields(["confirm"])
            setConfirmPwDisabled(true)
            return Promise.reject("Please enter your password");
        }
        if (!PASSWORD_VALIDATION.test(value)) {
            form.resetFields(["confirm"])
            setConfirmPwDisabled(true)
            return Promise.reject("Please enter a valid password");
        } else {
            setConfirmPwDisabled(false)
            return Promise.resolve();
        }
    };

    const preventDefaultEvent = (e: Event) => {
        e.preventDefault()
        return false;
    }

    const onGroupSelectChange = (values: number) => {
        form.resetFields(["managerCode", "rmCode", "agentCode"])
        if (values === 3) {
            setCanShowManagerCode(true)
            setCanShowRMCode(false)
            setCanShowAgentCode(false)
            setCanShowAdminUserType(false)
        } else if (values === 5) {
            setCanShowRMCode(true)
            setCanShowManagerCode(false);
            setCanShowAgentCode(false)
            setCanShowAdminUserType(false)
        } else if (values === 6) {
            setCanShowRMCode(false)
            setCanShowManagerCode(false);
            setCanShowAgentCode(true)
            setCanShowAdminUserType(true)
        } else {
            setCanShowAgentCode(true)
            setCanShowManagerCode(false);
            setCanShowRMCode(false)
            setCanShowAdminUserType(false)
        }
    }

    const switchUserStatus = (checked: boolean) => {
        setRecordStatus(checked);
    };
    const formatPhoneNumber = (number: string): string => {
        if (number.startsWith(addon)) {
            return number;
        }else if (number.startsWith("0")) {
            return addon + number.slice(1);
        }else {
            return addon + number;
        }
    };

    const addUser = () => {
        form.validateFields().then(() => {
            setLoading(true)

            let values = form.getFieldsValue();
            let rmCode = values.rmCode;
            let managerCode = values.managerCode;
            let userMstDto: UserMstDto = values
            userMstDto.contact = formatPhoneNumber(values.contact)
            let userAttributes: any
            let agentCode: string | undefined;
            if (undefined != rmCode) {
                userAttributes = {
                    "rm_code": String(rmCode)
                }
                agentCode = String(rmCode)
            }
            if (undefined != managerCode) {
                userAttributes = {
                    "manager_code": String(managerCode)
                }
                agentCode = String(managerCode)
            }
            if (undefined == agentCode) {
                agentCode = userMstDto.agentCode
            }
            if (null != agentCode && userMstDto.reportingToAgentCode
                && agentCode == userMstDto.reportingToAgentCode) {
                message.error(MSG_SAME_AGENT_CODE_ERROR)
                setLoading(false);
                return;
            }
            if (values.dateOfBirth) {
                userMstDto.dateOfBirth = values.dateOfBirth.format("YYYY-MM-DD");
            }
            userMstDto.userAttributes = userAttributes
            if (isUpdateUser) {
                if (checkFieldUpdates(initialFormValues as UserMstDto, values as UserMstDto)) {
                    userMstDto.userId = userId
                    userMstDto.recordStatus = recordStatus
                    signupService.updateAdminUsers(userMstDto).then((res) => {
                        if (res.data.results) {
                            message.success(MSG_ADMIN_USER_UPDATED_SUCCESS)
                            handleCancel()
                            getAllAdminUsers()
                            setLoading(false)
                        } else {
                            message.error(MSG_ADMIN_USER_UPDATE_FAILURE)
                            setLoading(false)
                        }
                    }, (reason) => {
                        ErrorHandler.handleError(reason);
                        setLoading(false)
                    })
                } else {
                    message.warning(MSG_NO_CHANGES_TO_UPDATE)
                    handleCancel()
                    getAllAdminUsers()
                    setLoading(false)
                }
            } else {
                signupService.createAdminUsers(userMstDto).then((res) => {
                    if (res.data.results) {
                        message.success(MSG_ADMIN_USER_CREATED_SUCCESS)
                        handleCancel()
                        getAllAdminUsers()
                        setLoading(false)
                    } else {
                        message.error(MSG_ADMIN_USER_CREATED_FAILURE)
                        setLoading(false)
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    setLoading(false)
                })
            }
        }).catch(() => {
        });
    }

    /*    const base64Salt = '0123456789abcdef';
        const base64Key = '0123456789abcdef';

        const salt = CryptoJS.enc.Base64.parse(base64Salt);
        const key = CryptoJS.enc.Base64.parse(base64Key);

        const encryptPassword = (password: string): string => {
            const encrypted = CryptoJS.AES.encrypt(password, key, {
                iv: salt,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });

            const encryptedStr = encrypted.toString();
            return encryptedStr;
        };*/

    const resetPassword = () => {
        restForm.validateFields().then(() => {
            setLoading(true)
            let values = restForm.getFieldsValue();
            let userMstDto: UserMstDto = values
            userMstDto.userName = form.getFieldValue('userName')

            // const encryptedConfirmPassword = encryptPassword(values.password);

            let passwordDetailDto = {
                userName: userMstDto.userName,
                password: values.password
            }

            signupService.userPasswordReset(passwordDetailDto).then((res) => {
                if (res.data.results) {
                    message.success(MSG_PASSWORD_UPDATED_SUCCESS)
                    handleCancel()
                    getAllAdminUsers()
                    setLoading(false)
                } else {
                    message.error(MSG_PASSWORD_UPDATE_FAILURE)
                    setLoading(false)
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setLoading(false)
            })
        }).catch(() => {
        })
    }

    return (
        <div>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}
                     className='page-header-main-title-col internal-user-header'>
                    <h2 className='page-header-main-title'>
                        <div className='header_icon header-icon-center'>
                            <FontAwesomeIcon icon={faUserGear}/>
                        </div>
                         Admin User List
                    </h2>
                    <Button type="primary" icon={<UserAddOutlined/>} onClick={showModal}>Add New User</Button>

                </Col>
            </Row>

            <Row gutter={[16, 16]} style={{marginTop: 30}}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Table scroll={{x: 'max-content'}} columns={columns} dataSource={adminUserList}
                           loading={isLoading}/>
                </Col>
            </Row>

            <Modal title={modalTitle}
                   className={'internal-user-create-modal'}
                   open={isModalOpen}
                   footer={null}
                   onCancel={handleCancel}
                   width={800}
                   centered
                   style={{top: 20, paddingBottom: 20}}
                   destroyOnClose={true}
                   maskClosable={false}>
                <Spin spinning={isLoading}>
                    <Row gutter={[24, 12]} className={'form-item-mb-12 modal-body-scroll-only-main-row'}
                         style={{marginTop: 18}}>
                        <Col span={24}>
                            <Form
                                className='form-input'
                                layout={"vertical"}
                                form={form}
                            >
                                <Card title={'Systems Details'} style={{marginBottom: 24}}>
                                    <Row gutter={[24, 0]}>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                            {

                                            }
                                            <Form.Item className='userNameFormItem'
                                                       label="Username"
                                                       name="userName"
                                                       onKeyPress={Validation.alphanumericAndSpecificSpecialCharactersForUsername}
                                                       validateTrigger={["onBlur"]}
                                                       rules={[
                                                           {required: true, message: 'Please select username'},
                                                           {min: 4, message: 'Minimum of 4 characters are required'},
                                                           {max: 20, message: 'The maximum length is 20 characters'},
                                                           {
                                                               pattern: USERNAME_VALIDATION,
                                                               message: "Please enter valid username"
                                                           },
                                                           {validator: validateUsername}
                                                       ]}>
                                                <Input autoComplete="new-username" placeholder="Enter username"
                                                       disabled={isCanShowUpdate || isUpdateUser}/>
                                            </Form.Item>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                            <Form.Item

                                                label={"Email"}
                                                name="email"
                                                onKeyPress={Validation.emailFieldValidation}
                                                rules={[
                                                    {required: true, message: 'Please enter your email'},
                                                    {
                                                        max: EMAIL_MAX_LENGTH,
                                                        message: 'The maximum length is 254 characters'
                                                    },
                                                    {
                                                        type: 'email',
                                                        validator: validateEmail
                                                    },

                                                ]}>
                                                <Input className={"email_input_width"}
                                                       placeholder="Enter email" disabled={isCanShowUpdate}/>
                                            </Form.Item>
                                        </Col>

                                        {!isCanShowUpdate && !isUpdateUser ?
                                            <>
                                                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                                    <Form.Item
                                                        label={<><span className='custom-astrix'>*</span> Password
                                                            <Tooltip placement="right" className='password-info-tooltip'
                                                                     title={
                                                                         <ul style={{
                                                                             padding: '0 10px 0 18px',
                                                                             width: '100%'
                                                                         }}>
                                                                             <li>Minimum 8 characters</li>
                                                                             <li>Maximum 20 characters</li>
                                                                             <li>Should have at least one uppercase</li>
                                                                             <li>Should have at least one lowercase</li>
                                                                             <li>Should have at least one numerical
                                                                                 value
                                                                             </li>
                                                                             <li>Should have at least one special
                                                                                 character
                                                                                 (!, @, #, $,
                                                                                 %, ^, &,
                                                                                 _,
                                                                                 or
                                                                                 *)
                                                                             </li>
                                                                         </ul>
                                                                     }>
                                                                <QuestionCircleOutlined
                                                                    style={{
                                                                        marginLeft: 5,
                                                                        color: '#108ee9',
                                                                        fontSize: 16
                                                                    }}/>
                                                            </Tooltip>
                                                        </>}
                                                        name="password"
                                                        rules={[
                                                            {validator: validatePassword},
                                                        ]}
                                                        onKeyPress={Validation.passwordFieldValidation}
                                                        hasFeedback>
                                                        <Input.Password placeholder="Enter password"
                                                                        autoComplete="new-password"
                                                                        onCopy={preventDefaultEvent}
                                                                        onPaste={preventDefaultEvent}
                                                                        disabled={isCanShowUpdate}/>
                                                    </Form.Item>
                                                </Col>

                                                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                                    <Form.Item
                                                        label="Confirm Password"
                                                        name="confirm"
                                                        dependencies={['password']}
                                                        rules={
                                                            [{
                                                                required: true,
                                                                message: 'Please enter your confirm password'
                                                            },
                                                                // {max: 20, message: 'The maximum length is 20 characters'},
                                                                // {min: 8, message: 'Minimum of 8 characters are required'},
                                                                ({getFieldValue}: any) => ({
                                                                    validator(_: any, value: any) {
                                                                        if (!value || getFieldValue('password') === value) {
                                                                            return Promise.resolve();
                                                                        }
                                                                        return Promise.reject(new Error('Confirm password do not match'));
                                                                    },
                                                                })

                                                            ]}
                                                        onKeyPress={Validation.passwordFieldValidation}
                                                        hasFeedback>
                                                        <Input.Password disabled={isConfirmPasswordDisabled}
                                                                        autoComplete="none"
                                                                        placeholder="Enter confirm password"
                                                                        onCopy={preventDefaultEvent}
                                                                        onPaste={preventDefaultEvent}/>
                                                    </Form.Item>
                                                </Col>
                                            </> : <></>}

                                        <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
                                            <Form.Item
                                                label="User Rank"
                                                name={"userTypeId"}
                                                rules={[{required: true, message: 'Please select user rank'}]}>
                                                <Select placeholder={"Select user rank"}
                                                        disabled={isCanShowUpdate}
                                                    // mode="multiple"
                                                        allowClear
                                                        getPopupContainer={(trigger: {
                                                            parentNode: any;
                                                        }) => trigger.parentNode}
                                                        style={{width: '100%'}}
                                                        options={userList?.map((group) => ({
                                                            value: group.value,
                                                            label: group.label,
                                                            key: group.value
                                                        }))}
                                                        onChange={(e: number) => onGroupSelectChange(e)}
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterOption={(input: any, option: {
                                                            label: any;
                                                        }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                />
                                            </Form.Item>
                                        </Col>
                                        {isCanShowAdminUserType ?
                                            <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
                                                <Form.Item
                                                    label="Admin User Type"
                                                    name={"adminUserTypeIdList"}
                                                    rules={[{
                                                        required: isCanShowAdminUserType,
                                                        message: 'Please select admin user type'
                                                    }]}>
                                                    <Select placeholder={"Select admin user type"}
                                                            disabled={isCanShowUpdate}
                                                            mode="multiple"
                                                            allowClear
                                                            getPopupContainer={(trigger: {
                                                                parentNode: any;
                                                            }) => trigger.parentNode}
                                                            style={{width: '100%'}}
                                                            options={adminList?.map((group) => ({
                                                                value: group.value,
                                                                label: group.label,
                                                                key: group.value
                                                            }))}
                                                            showSearch
                                                            optionFilterProp="children"
                                                            filterOption={(input: any, option: {
                                                                label: any;
                                                            }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                    />
                                                </Form.Item>
                                            </Col> : <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}></Col>}

                                        <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
                                            <Form.Item
                                                label="Reporting To"
                                                name={"reportingToAgentCode"}
                                                rules={[{required: isCanShowRMCode, message: 'Please select reporting to'}]}>
                                                <Select placeholder={"Select reporting to"}
                                                        disabled={isCanShowUpdate}
                                                        allowClear
                                                        getPopupContainer={(trigger: {
                                                            parentNode: any;
                                                        }) => trigger.parentNode}
                                                        style={{width: '100%'}}
                                                        options={reportingToList?.map((group) => ({
                                                            value: group.value,
                                                            label: group.label,
                                                            key: group.value
                                                        }))}
                                                    // onChange={(e: string[]) => onGroupSelectChange(e)}
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterOption={(input: any, option: {
                                                            label: any;
                                                        }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                />
                                            </Form.Item>
                                        </Col>
                                        {isCanShowRMCode ?
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                                <Form.Item
                                                    label="RM Code"
                                                    name={"rmCode"}
                                                    onKeyPress={Validation.isNumberWithoutDot}
                                                    rules={[
                                                        {required: true, message: 'Please enter rm code'},
                                                        {validator: validateAgentCode}
                                                    ]}>
                                                    <Input placeholder={"Enter RM Code"} disabled={isCanShowUpdate}/>
                                                </Form.Item>
                                            </Col> : <></>}
                                        {isCanShowManagerCode ?
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                                <Form.Item
                                                    label="Manager Code"
                                                    name={"managerCode"}
                                                    onKeyPress={Validation.isNumberWithoutDot}
                                                    rules={[
                                                        {required: true, message: 'Please enter manager code'},
                                                        {validator: validateAgentCode}
                                                    ]}>
                                                    <Input placeholder={"Enter Manager Code"}
                                                           disabled={isCanShowUpdate}/>
                                                </Form.Item>
                                            </Col> : <></>}
                                        {isCanShowAgentCode ?
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                                <Form.Item
                                                    label="Agent Code"
                                                    name={"agentCode"}
                                                    rules={[
                                                        {required: false, message: 'Please enter agent code'},
                                                        {validator: validateAgentCode}
                                                    ]}>
                                                    <Input placeholder={"Enter Agent Code"}
                                                           disabled={isCanShowUpdate}/>
                                                </Form.Item>
                                            </Col> : <></>}
                                    </Row>
                                </Card>


                                <Card title={'User Details'}>
                                    <Row gutter={[24, 0]}>
                                        <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
                                            <Form.Item
                                                label="Title"
                                                name={"salutationId"}
                                                rules={[{required: true, message: 'Please enter title'}]}>
                                                <Select placeholder={"Select title"}
                                                        disabled={isCanShowUpdate}
                                                        allowClear
                                                        getPopupContainer={(trigger: {
                                                            parentNode: any;
                                                        }) => trigger.parentNode}
                                                        style={{width: '100%'}}
                                                        options={salutationList?.map((group) => ({
                                                            value: group.value,
                                                            label: group.label,
                                                            key: group.value
                                                        }))}
                                                    // onChange={(e: string[]) => onGroupSelectChange(e)}
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterOption={(input: any, option: {
                                                            label: any;
                                                        }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                            <Form.Item

                                                label={"First Name"}
                                                name="firstName"
                                                // onKeyPress={Validation.emailFieldValidation}
                                                rules={[
                                                    {required: true, message: 'Please enter your first name'}]}>
                                                <Input className={"email_input_width"}
                                                       placeholder="Enter first name" disabled={isCanShowUpdate}/>
                                            </Form.Item>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                            <Form.Item

                                                label={"Last Name"}
                                                name="lastName">
                                                <Input className={"email_input_width"}
                                                       placeholder="Enter last name"
                                                       disabled={isCanShowUpdate}/>
                                            </Form.Item>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                            <Form.Item

                                                label={"Address Line 1"}
                                                name="address1">
                                                <Input className={"email_input_width"}
                                                       placeholder="Enter address line 1"
                                                       disabled={isCanShowUpdate}/>
                                            </Form.Item>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                            <Form.Item

                                                label={"Address Line 2"}
                                                name="address2">
                                                <Input className={"email_input_width"}
                                                       placeholder="Enter address line 2"
                                                       disabled={isCanShowUpdate}/>
                                            </Form.Item>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                            <Form.Item

                                                label={"Postal Code"}
                                                name="postalCode">
                                                <Input className={"email_input_width"}
                                                       placeholder="Enter postal code"
                                                       disabled={isCanShowUpdate}/>
                                            </Form.Item>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                            <Form.Item
                                                label={"Date of birth"}
                                                name="dateOfBirth">
                                                <DatePicker className={'datepicker-small-size'}
                                                            placement='bottomLeft' showToday={false}
                                                            disabled={isCanShowUpdate}
                                                    // disabledDate={(d: {
                                                    //     isAfter: (arg0: dayjs.Dayjs) => any;
                                                    // }) => !d || d.isAfter(dayjs().add(-1, 'day'))}
                                                            style={{width: '100%'}}
                                                            placeholder={"Select date of birth"}/>
                                            </Form.Item>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                            <Form.Item

                                                label={"NIC"}
                                                name="nic"
                                                onKeyPress={Validation.nicFieldValidation}
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: 'Please enter NIC number'
                                                    },
                                                    {
                                                        pattern: NIC_VALIDATION,
                                                        message: "Please enter a valid NIC number"
                                                    },]}>
                                                <Input className={"email_input_width"}
                                                       placeholder="Enter nic"
                                                       disabled={isCanShowUpdate}/>
                                            </Form.Item>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                            <Form.Item

                                                label={"Land Phone"}
                                                name="landPhoneNo"
                                                onKeyPress={Validation.isNumberWithoutDot}
                                                rules={[
                                                    {
                                                        max: MOBILE_NUMBER_MAX_LENGTH,
                                                        message: 'The maximum length is 15 numbers'
                                                    },
                                                    {
                                                        pattern: ONLY_NUMERIC_VALIDATION,
                                                        message: 'These special characters are not allowed'
                                                    }]}>
                                                <Input className={"email_input_width"}
                                                       placeholder="Enter land phone number"
                                                       disabled={isCanShowUpdate}/>
                                            </Form.Item>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                            <Form.Item

                                                label={"Mobile Phone"}
                                                name="contact"
                                                onKeyPress={Validation.isNumberWithoutDot}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please enter mobile phone no'
                                                    },
                                                    {
                                                        max: MOBILE_NUMBER_MAX_LENGTH,
                                                        message: 'The maximum length is 15 numbers'
                                                    },
                                                    {
                                                        pattern: ONLY_NUMERIC_VALIDATION,
                                                        message: 'These special characters are not allowed'
                                                    }]}>
                                                <Input addonBefore={addon} className={"email_input_width"}
                                                       placeholder="Enter mobile number"
                                                       disabled={isCanShowUpdate}/>
                                            </Form.Item>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                            <Form.Item

                                                label={"FAX"}
                                                name="fax"
                                                onKeyPress={Validation.isNumberWithoutDot}
                                                rules={[
                                                    {
                                                        max: MOBILE_NUMBER_MAX_LENGTH,
                                                        message: 'The maximum length is 15 numbers'
                                                    },
                                                    {
                                                        pattern: ONLY_NUMERIC_VALIDATION,
                                                        message: 'These special characters are not allowed'
                                                    }]}>
                                                <Input className={"email_input_width"}
                                                       placeholder="Enter fax number"
                                                       disabled={isCanShowUpdate}/>
                                            </Form.Item>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                            <Form.Item
                                                label={"User Status"}
                                                name="recordStatus"
                                                valuePropName="checked">
                                                <Switch
                                                    checkedChildren="Active"
                                                    unCheckedChildren="Inactive"
                                                    onChange={(checked: boolean) => {
                                                        switchUserStatus(checked)
                                                    }}
                                                    disabled={isCanShowUpdate}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                            </Form>
                        </Col>

                        <Col span={24}>
                            <Space style={{float: 'right'}}>
                                {isCanShowUpdate ?
                                    // <Button icon={<EditOutlined/>} type="success" onClick={updateUser}
                                    //         style={{
                                    //             width: 100,
                                    //             background: "#008d86",
                                    //             color: "white",
                                    //         }}>Update</Button>
                                    <></>
                                    :
                                    <Button icon={<SaveOutlined/>} type="success" onClick={addUser}
                                            style={{
                                                width: 100,
                                                background: "#008d86",
                                                color: "white", marginTop: 8
                                            }}>Submit</Button>}
                            </Space>
                        </Col>
                        <Col span={24}>
                            <Divider style={{marginBottom: 8, marginTop: 8}}></Divider>
                        </Col>
                        <Col span={24}>
                            <Form

                                className='form-input'
                                layout={"vertical"}
                                form={restForm}>
                                {isUpdateUser ?
                                    <>
                                        <Card title={'Reset Password'}>
                                            <Row gutter={[24, 0]}>
                                                <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
                                                    <Form.Item
                                                        label={<><span className='custom-astrix'>*</span> Password
                                                            <Tooltip placement="right" className='password-info-tooltip'
                                                                     title={
                                                                         <ul style={{
                                                                             padding: '0 10px 0 18px',
                                                                             width: '100%'
                                                                         }}>
                                                                             <li>Minimum 8 characters</li>
                                                                             <li>Maximum 20 characters</li>
                                                                             <li>Should have at least one uppercase</li>
                                                                             <li>Should have at least one lowercase</li>
                                                                             <li>Should have at least one numerical
                                                                                 value
                                                                             </li>
                                                                             <li>Should have at least one special
                                                                                 character
                                                                                 (!, @, #, $,
                                                                                 %, ^, &,
                                                                                 _,
                                                                                 or
                                                                                 *)
                                                                             </li>
                                                                         </ul>
                                                                     }>
                                                                <QuestionCircleOutlined
                                                                    style={{
                                                                        marginLeft: 5,
                                                                        color: '#108ee9',
                                                                        fontSize: 16
                                                                    }}/>
                                                            </Tooltip>
                                                        </>}
                                                        name="password"
                                                        rules={[
                                                            {validator: validatePassword},
                                                        ]}
                                                        onKeyPress={Validation.passwordFieldValidation}
                                                        hasFeedback>
                                                        <Input.Password placeholder="Enter password"
                                                                        autoComplete="new-password"
                                                                        onCopy={preventDefaultEvent}
                                                                        onPaste={preventDefaultEvent}
                                                                        disabled={isCanShowUpdate}/>
                                                    </Form.Item>
                                                </Col>

                                                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                                    <Form.Item
                                                        label="Confirm Password"
                                                        name="confirm"
                                                        dependencies={['password']}
                                                        rules={
                                                            [{
                                                                required: true,
                                                                message: 'Please enter your confirm password'
                                                            },
                                                                // {max: 20, message: 'The maximum length is 20 characters'},
                                                                // {min: 8, message: 'Minimum of 8 characters are required'},
                                                                ({getFieldValue}: any) => ({
                                                                    validator(_: any, value: any) {
                                                                        if (!value || getFieldValue('password') === value) {
                                                                            return Promise.resolve();
                                                                        }
                                                                        return Promise.reject(new Error('Confirm password do not match'));
                                                                    },
                                                                })

                                                            ]}
                                                        onKeyPress={Validation.passwordFieldValidation}
                                                        hasFeedback>
                                                        <Input.Password disabled={isConfirmPasswordDisabled}
                                                                        autoComplete="none"
                                                                        placeholder="Enter confirm password"
                                                                        onCopy={preventDefaultEvent}
                                                                        onPaste={preventDefaultEvent}/>
                                                    </Form.Item>
                                                </Col>

                                            </Row>
                                        </Card>
                                        <Row gutter={[24, 0]}>
                                            <Col span={24}>
                                                <Space style={{float: 'right'}}>
                                                    <Button icon={<ReloadOutlined/>} type="success"
                                                            onClick={resetPassword}
                                                            style={{
                                                                width: 100,
                                                                background: "#ff7400",
                                                                color: "white",
                                                                marginTop: 18
                                                            }}>Reset</Button>
                                                </Space>
                                            </Col>
                                        </Row>
                                    </> : <></>}
                            </Form>
                        </Col>

                    </Row>
                </Spin>

            </Modal>
        </div>


    )

}
export default InternalUsersList;

